<template>
	<div>
		<span v-for="(value, name) in params.value" :key="name"> {{ name }}: {{ value }} {{ "|" }} </span>
	</div>
</template>

<script>
export default {
	name: "CellRendererStatus",
	computed: {
		getProperties() {
			return (value) => {
				return Object.values(value);
			};
		},
	},
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
	&.vs-chip-success {
		background: rgba(var(--vs-success), 0.15);
		color: rgba(var(--vs-success), 1) !important;
		font-weight: 500;
	}
	&.vs-chip-warning {
		background: rgba(var(--vs-warning), 0.15);
		color: rgba(var(--vs-warning), 1) !important;
		font-weight: 500;
	}
	&.vs-chip-danger {
		background: rgba(var(--vs-danger), 0.15);
		color: rgba(var(--vs-danger), 1) !important;
		font-weight: 500;
	}
}
</style>
